import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export const getMembers = async (
  companyId: number,
  config?: AxiosRequestConfig,
) => {
  interface User {
    id: number
    name: string
    email: string
    role: 'admin' | 'owner' | 'member'
  }

  const { data } = await companiesApi.get<User[]>(
    `${apiRoutes.getMembers}/${companyId}`,
    config,
  )

  return data
}
